var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 58,
    viewBox: "0 0 64 58",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m63.1543 42.42c0-8.1447-5.7507-14.4228-14.7149-14.0835.8456-11.3685 9.6408-21.20995 15.5606-25.79129l-1.6914-2.54521c-12.347 7.80527-27.9077 23.9249-27.9077 40.5535 0 9.5021 5.4124 16.4589 14.2076 16.4589 8.7951 0 14.5458-6.7872 14.5458-14.5924zm-34.4009 0c0-8.1447-5.7507-14.4228-14.715-14.0835.8457-11.3685 9.6408-21.20995 15.5606-25.79129l-1.6913-2.54521c-12.3471 7.80527-27.9077 23.9249-27.9077 40.5535 0 9.5021 5.41239 16.4589 14.2075 16.4589 8.7952 0 14.5459-6.7872 14.5459-14.5924z",
    fill: "#1c1d1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.fe11278aa05caa6c32f63fd220483042.svg";
export { ForwardRef as ReactComponent };